// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f2c6a454","79":"3ed3ab74","453":"fe2c89a5","511":"9534a7da","732":"11bbeb41","746":"1807b636","762":"dfb882cf","886":"f2b5495c","929":"f6ec5cb5","977":"91169c36","992":"35b7ca97"}[chunkId] + ".chunk.js";
};